/** Fashion is season-bounded; NOOS is continuous. React-free, so the server can use it too. */
export type CollectionKind = "fashion" | "noos"

export const kindOf = (c: { collectionType: string | null }): CollectionKind =>
  (c.collectionType ?? "").toLowerCase() === "noos" ? "noos" : "fashion"
